import Vue from 'vue'
import appConfig from '@/config.js'
import store from '@/store'

const ApiService = {
  getAll(resource, params) {
    console.log('============ API CALL')
    console.log('GET ' + appConfig.api.baseUrl + resource)
    console.log(params)
    console.log('============')
    return Vue.http.get(appConfig.api.baseUrl + resource, params)
  },

  get(resource, id = '', params) {
    console.log('============ API CALL')
    console.log('GET ' + `${appConfig.api.baseUrl}${resource}/${id}`)
    console.log(params)
    console.log('============')
    return Vue.http.get(`${appConfig.api.baseUrl}${resource}/${id}`, params)
  },

  post(resource, params) {
    console.log('============ API CALL')
    console.log('POST ' + appConfig.api.baseUrl + resource)
    console.log(params)
    console.log('============')
    return Vue.http.post(`${appConfig.api.baseUrl}${resource}`, params)
  },

  update(resource, id, params) {
    console.log('============ API CALL')
    console.log('PATCH ' + appConfig.api.baseUrl + resource)
    console.log(params)
    console.log('============')
    return Vue.http.patch(`${appConfig.api.baseUrl}${resource}/${id}`, params)
  },

  put(resource, params) {
    console.log('============ API CALL')
    console.log('PUT ' + appConfig.api.baseUrl + resource)
    console.log(params)
    console.log('============')
    return Vue.http.put(`${appConfig.api.baseUrl}${resource}`, params)
  },

  patch(resource, params) {
    console.log('============ API CALL')
    console.log('PATCH ' + appConfig.api.baseUrl + resource)
    console.log(params)
    console.log('============')
    return Vue.http.patch(`${appConfig.api.baseUrl}${resource}`, params)
  },

  delete(resource, params) {
    console.log('============ API CALL')
    console.log('DELETE ' + appConfig.api.baseUrl + resource)
    console.log('============')
    return Vue.http.delete(appConfig.api.baseUrl + resource, params)
  }
}

export default ApiService

export const ConfigService = {
  getEcosystems(params) {
    return ApiService.getAll('ecosystems', params)
  },
  getEcosystem(id, params) {
    return ApiService.get('ecosystems', id, params)
  },
  getCountries(params) {
    return ApiService.getAll('countries', params)
  },
  getRoles(params) {
    return ApiService.getAll('roles', params)
  },
  getVehicleTypes(params) {
    return ApiService.getAll('vehicle-types', params)
  },
  getShippingSizes(params) {
    return ApiService.getAll('sizes', params)
  },
  getShippingTypes(params) {
    return ApiService.getAll('shipping-types', params)
  },
  getShippingSettings(params) {
    return ApiService.getAll('shipping-setting-options', params)
  },
  getPlatforms(params) {
    return ApiService.getAll('platforms', params)
  },
  getReceiverTypes(params) {
    return ApiService.getAll('receiver-types', params)
  },
  getShippingStatusReasons(params) {
    return ApiService.getAll('shipping-status-reasons', params)
  },
  getGeoTypes(params) {
    return ApiService.getAll('geo-types', params)
  }
}

export const ProfileService = {
  get(params) {
    return ApiService.get('users', store.getters.uid, params)
  },
  update(params) {
    return ApiService.update('users', store.getters.uid, params)
  },
  changePassword(params) {
    return ApiService.put(`users/${store.getters.uid}/change-password`, params)
  },
  emailPassword(params) {
    return ApiService.post(`password/email`, params)
  },
  resetPassword(params) {
    return Vue.http.post(`${appConfig.api.baseUrl}password/reset`, params, {before: (req) => req.headers.set('x-moova-ecosystem-id', params.ecosystem_id || 1)})
  }
}

export const UserService = {
  getAll(params) {
    const resource = window.product === 'carriers' ? 'companies/users' : 'users'
    return ApiService.getAll(resource, params)
  },
  get(id, params) {
    const resource = window.product === 'carriers' ? 'companies/users' : 'users'
    return ApiService.get(resource, id, params)
  },
  create(params) {
    return ApiService.post('companies/users', params)
  },
  update(id, params) {
    const resource = window.product === 'carriers' ? 'companies/users' : 'users'
    return ApiService.update(resource, id, params)
  },
  enable(id, params) {
    const resource = window.product === 'carriers' ? `companies/users/${id}/enable` : `users/${id}/enable`
    return ApiService.post(resource, params)
  },
  disable(id, params) {
    const resource = window.product === 'carriers' ? `companies/users/${id}/disable` : `users/${id}/disable`
    return ApiService.delete(resource, params)
  },
  addRole(id, params) {
    const resource = window.product === 'carriers' ? `companies/users/${id}/roles` : `users/${id}/roles`
    return ApiService.post(resource, params)
  },
  removeRole(id, params) {
    const resource = window.product === 'carriers' ? `companies/users/${id}/roles` : `users/${id}/roles`
    return ApiService.delete(resource, params)
  },
  changePassword(params) {
    const resource = window.product === 'carriers' ? `carriers/users/change-password` : `users/change-password`
    return ApiService.put(resource, params)
  },
  changePhone(params) {
    return ApiService.patch(`users/change-phone`, params)
  },
  addAddress(id, params) {
    return ApiService.post(`users/${id}/addresses`, params)
  },
  updateAddress(id, fk, params) {
    return ApiService.update(`users/${id}/addresses`, fk, params)
  },
  deleteAddress(id, fk, params) {
    return ApiService.delete(`users/${id}/addresses/${fk}`, params)
  },
  addVehicle(id, params) {
    return ApiService.post(`users/${id}/vehicles`, params)
  },
  updateVehicle(id, fk, params) {
    return ApiService.update(`users/${id}/vehicles`, fk, params)
  },
  deleteVehicle(id, fk, params) {
    return ApiService.delete(`users/${id}/vehicles/${fk}`, params)
  }
}

export const CompanyService = {
  getAll(params) {
    return ApiService.getAll('companies', params)
  },
  get(id, params) {
    return ApiService.get('companies', id, params)
  },
  create(params) {
    return ApiService.post('gcm/companies', params)
  },
  update(id, params) {
    return ApiService.update('gcm/companies', id, params)
  },
  delete(id, params) {
    return ApiService.delete(`gcm/companies/${id}`, params)
  },
  enable(id, params) {
    return ApiService.put(`companies/${id}/approve`, params)
  },
  disable(id, params) {
    return ApiService.put(`companies/${id}/disable`, params)
  },
  createUser(params) {
    return ApiService.post('companies/users', params)
  },
  // addRole(id, params) {
  //   return ApiService.post(`users/${id}/roles`, params)
  // },
  // removeRole(id, params) {
  //   return ApiService.delete(`users/${id}/roles`, params)
  // },
  // changePassword(params) {
  //   return ApiService.put(`users/change-password`, params)
  // },
  // changePhone(params) {
  //   return ApiService.patch(`users/change-phone`, params)
  // },
  // addAddress(id, params) {
  //   return ApiService.post(`users/${id}/addresses`, params)
  // },
  // updateAddress(id, fk, params) {
  //   return ApiService.update(`users/${id}/addresses`, fk, params)
  // },
  // deleteAddress(id, fk, params) {
  //   return ApiService.delete(`users/${id}/addresses`, fk, params)
  // },
  addVehicle(id, params) {
    return ApiService.post(`companies/${id}/vehicles`, params)
  },
  updateVehicle(id, fk, params) {
    return ApiService.update(`companies/${id}/vehicles`, fk, params)
  },
  deleteVehicle(id, fk, params) {
    return ApiService.delete(`companies/${id}/vehicles/${fk}`, params)
  }
}

export const TourService = {
  getAll(params) {
    return ApiService.getAll('tours', params)
  },
  get(id, params) {
    return ApiService.get('tours', id, params)
  },
  create(params) {
    return ApiService.post('tours', params)
  },
  update(id, params) {
    return ApiService.update('tours', id, params)
  },
  addShippings(id, params) {
    return ApiService.post(`tours/${id}/shippings`, params)
  },
  removeShippings(id, params) {
    return ApiService.delete(`tours/${id}/shippings`, params)
  },
  generateRoute(id, params) {
    return ApiService.post(`tours/${id}/generate-route`, params)
  },
  unassignCourier(id) {
    return ApiService.post(`tours/${id}/reject`)
  },
  cancelTour(id) {
    return ApiService.post(`tours/${id}/cancel`)
  },
  recalculateBudget(id) {
    return ApiService.put(`tours/${id}/budgets/recalculate`)
  }
}

export const ShippingService = {
  getAll(params) {
    const resource = window.product === 'carriers' ? `carriers/${store.getters.profile.company_id}/shippings` : `shippings`
    return ApiService.getAll(resource, params)
  },
  get(id, params) {
    const resource = window.product === 'carriers' ? `carriers/${store.getters.profile.company_id}/shippings` : `shippings`
    return ApiService.get(resource, id, params)
  },
  create(payload) {
    return ApiService.post('shippings', payload)
  },
  update(id, payload) {
    const resource = window.product === 'carriers' ? `carriers/${store.getters.profile.company_id}/shippings` : `shippings`
    return ApiService.update(resource, id, payload)
  },
  changeStatus(payload) {
    return ApiService.post('status', payload)
  },
  attachFile(id, payload) {
    const formData = new FormData()
    formData.append('file', payload.file, payload.file.name)
    return ApiService.post('files', formData)
      .then(response => {
        payload.full_path = response.body.full_path
        if (!payload.comment) {
          delete payload.comment
        }
        if (!payload.type) {
          delete payload.type
        }
        return ApiService.post(`shippings/${id}/photos`, payload)
      })
  },
  deleteAttachment(id, attachmentId) {
    return ApiService.delete(`shippings/${id}/photos/${attachmentId}`)
  }
}

export const ShippingOrderService = {
  getAll(params) {
    return ApiService.getAll('shipping-orders', params)
  },
  get(id, params) {
    return ApiService.get('shipping-orders', id, params)
  },
  create(params) {
    return ApiService.post('shipping-orders', params)
  },
  update(id, params) {
    return ApiService.update('shipping-orders', id, params)
  }
}

export const ItemService = {
  getAll(params, gcm = false) {
    if (!gcm) {
      return ApiService.getAll('items', params)
    } else {
      return ApiService.getAll('gcm/items', params)
    }
  },
  get(id, params, gcm = false) {
    if (!gcm) {
      return ApiService.get('items', id, params)
    } else {
      return ApiService.get('gcm/items', id, params)
    }
  },
  getShippingHistory(params) {
    return ShippingService.getAll(params)
  },
  addToShipping(itemId, shippingId) {
    return ApiService.post(`shippings/${shippingId}/items/${itemId}`) // 'items', id, { shipping_id: shippingId })
  },
  removeFromShipping(itemId, shippingId) {
    return ApiService.delete(`shippings/${shippingId}/items/${itemId}`)
  },
  enable(id, params) {
    return ApiService.update('items', id, { active: true })
  },
  disable(id, params) {
    return ApiService.update('items', id, { active: false })
  },
  getTrackingHistory(params) {
    return ApiService.getAll('items-tracking/history', params)
  },
  getTrackingHistoryEvents(params) {
    return ApiService.getAll('items-tracking/history/events', params)
  }
}

export const TrackingService = {
  getAll(params) {
    return ApiService.getAll('tracking-history', params)
  }
}

export const FixedPriceService = {
  delete(id, params) {
    return ApiService.delete(`fixed-amount-price-schedules/${id}`, params)
  }
}

export const GeofenceService = {
  getAll(params) {
    return ApiService.getAll('geo-fences', params)
  },
  get(id, params) {
    return ApiService.get('geo-fences', id, params)
  },
  create(params) {
    return ApiService.post('geo-fences', params)
  },
  update(id, params) {
    return ApiService.update('geo-fences', id, params)
  },
  delete(id, params) {
    return ApiService.delete(`geo-fences/${id}`, params)
  },
  fetchExternalData(params) {
    return ApiService.getAll('platforms/g3/locations', params)
  },
  addGeofence(parentId, childId) {
    let params = {
      geo_fence_id_parent: parentId,
      geo_fence_id_child: childId
    }
    return ApiService.post('geo-fence-geo-fences', params)
  },
  removeGeofence(parentId, childId) {
    return ApiService.delete(`geo-fences/${parentId}/geo-fence/${childId}`)
  },
  addGeoline(fenceId, lineId) {
    let params = {
      geo_fence_id: fenceId,
      geo_line_id: lineId
    }
    return ApiService.post('geo-fence-geo-lines', params)
  },
  removeGeoline(fenceId, lineId) {
    return ApiService.delete(`geo-fences/${fenceId}/geo-line/${lineId}`)
  },
  addGeopoint(fenceId, pointId) {
    let params = {
      geo_fence_id: fenceId,
      geo_point_id: pointId
    }
    return ApiService.post('geo-fence-geo-points', params)
  },
  removeGeopoint(fenceId, pointId) {
    return ApiService.delete(`geo-fences/${fenceId}/geo-point/${pointId}`)
  },
  getItems(fenceId, params) {
    return ApiService.getAll(`geo-fences/${fenceId}/items`, params)
  }
}

export const GeoLineService = {
  getAll(params) {
    return ApiService.getAll('geo-lines', params)
  },
  get(id, params) {
    return ApiService.get('geo-lines', id, params)
  },
  create(params) {
    return ApiService.post('geo-lines', params)
  },
  update(id, params) {
    return ApiService.update('geo-lines', id, params)
  },
  delete(id, params) {
    return ApiService.delete(`geo-lines/${id}`, params)
  }
}

export const GeoPointService = {
  getAll(params) {
    return ApiService.getAll('geo-points', params)
  },
  get(id, params) {
    return ApiService.get('geo-points', id, params)
  },
  create(params) {
    return ApiService.post('geo-points', params)
  },
  update(id, params) {
    return ApiService.update('geo-points', id, params)
  },
  delete(id, params) {
    return ApiService.delete(`geo-points/${id}`, params)
  }
}

export const GeoTypeService = {
  getAll(params) {
    return ApiService.getAll('geo-types', params)
  },
  get(id, params) {
    return ApiService.get('geo-types', id, params)
  },
  create(params) {
    return ApiService.post('geo-types', params)
  },
  update(id, params) {
    return ApiService.update('geo-types', id, params)
  }
}
